// extracted by mini-css-extract-plugin
export default {"MapElement":"MapElement_MapElement__lAQfx"};